/* eslint-disable no-use-before-define */
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import CockpitNavigation from './CockpitNavigation';
import {
  chargerBibliothequeGoldenCases,
  chargerRegistreInterpretation,
  creerGoldenCaseDepuisSimulation,
  detecterPreuvesDepuisLog,
  executerGoldenCase,
  executerGoldenCases,
  idFlux,
  libelleFlux,
  libelleProfil,
  sauvegarderBibliothequeGoldenCasesLocale,
  sauvegarderGoldenCaseLocal,
} from './laboratoireInterpretationService';
import {
  extraireEvenementsDepuisLog,
  fusionnerRegistreAvecBrouillon,
  genererEntreeIndexBrouillon,
  genererFluxBrouillon,
  genererProfilBrouillon,
  proposerIdentifiantFlux,
  regrouperEvenements,
} from './atelierCreationFluxService';

const PAGES_LABORATOIRE = [
  { cle: 'registre', chemin: '/cockpit/laboratoire-interpretation/flux', libelle: 'Registre des flux' },
  { cle: 'profils', chemin: '/cockpit/laboratoire-interpretation/profils', libelle: "Profils d'interpretation" },
  { cle: 'creation-flux', chemin: '/cockpit/laboratoire-interpretation/creation-flux', libelle: 'Creation de flux' },
  { cle: 'simulation', chemin: '/cockpit/laboratoire-interpretation/simulation', libelle: 'Simulation' },
  { cle: 'golden-cases', chemin: '/cockpit/laboratoire-interpretation/golden-cases', libelle: 'Golden Cases' },
];

const useStyles = makeStyles((theme) => ({
  page: { paddingTop: theme.spacing(3), paddingBottom: theme.spacing(4), textAlign: 'left' },
  paper: { padding: theme.spacing(2), marginBottom: theme.spacing(2), boxShadow: 'none', border: '1px solid #e5e7eb' },
  header: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(2), flexWrap: 'wrap', alignItems: 'flex-start' },
  muted: { color: '#6b7280', fontSize: 12 },
  nav: { display: 'flex', flexWrap: 'wrap', gap: theme.spacing(1), marginTop: theme.spacing(1.5) },
  layout: { display: 'grid', gridTemplateColumns: 'minmax(220px, 300px) 1fr', gap: theme.spacing(2) },
  liste: { border: '1px solid #e5e7eb', borderRadius: 6, overflow: 'hidden' },
  itemFlux: { width: '100%', justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none', borderRadius: 0, padding: theme.spacing(1.25) },
  itemFluxActif: { width: '100%', justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none', borderRadius: 0, padding: theme.spacing(1.25), backgroundColor: '#f3f4f6' },
  bloc: { border: '1px solid #e5e7eb', borderRadius: 6, padding: theme.spacing(1.5), marginBottom: theme.spacing(1.5), backgroundColor: '#fff' },
  grille: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: theme.spacing(1) },
  code: { fontFamily: 'monospace', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  tableScroll: { overflowX: 'auto' },
  chipInfo: { backgroundColor: '#eef2ff', color: '#3730a3', fontSize: 11 },
  chipOk: { backgroundColor: '#ecfdf5', color: '#065f46', fontSize: 11 },
  chipWarn: { backgroundColor: '#fff7ed', color: '#9a3412', fontSize: 11 },
  chipDanger: { backgroundColor: '#fef2f2', color: '#991b1b', fontSize: 11 },
  diagnosticHero: { border: '1px solid #bfdbfe', backgroundColor: '#eff6ff', padding: theme.spacing(2), marginBottom: theme.spacing(2) },
  diagnosticTitre: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1), flexWrap: 'wrap', alignItems: 'center', marginBottom: theme.spacing(1.5) },
  diagnosticMission: { fontSize: 28, fontWeight: 700, color: '#111827', lineHeight: 1.15, marginBottom: theme.spacing(1) },
  diagnosticEtat: { fontSize: 20, fontWeight: 600, color: '#1f2937', marginBottom: theme.spacing(1.25) },
  diagnosticRaison: { borderTop: '1px solid #bfdbfe', marginTop: theme.spacing(1), paddingTop: theme.spacing(1) },
  tutorielFlux: { border: '1px solid #c7d2fe', backgroundColor: '#f8fafc' },
  tutorielListe: { margin: 0, paddingLeft: theme.spacing(2.5), color: '#374151' },
  tutorielItem: { marginBottom: theme.spacing(0.75) },
  actionValidation: { display: 'flex', justifyContent: 'flex-end', gap: theme.spacing(1), flexWrap: 'wrap', marginTop: theme.spacing(1.5) },
  actionsInline: { display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap', alignItems: 'center' },
  select: { minWidth: 260, padding: theme.spacing(1), border: '1px solid #d1d5db', borderRadius: 4, backgroundColor: '#fff' },
  selectCompact: { width: '100%', minWidth: 150, padding: theme.spacing(0.75), border: '1px solid #d1d5db', borderRadius: 4, backgroundColor: '#fff' },
  zoneVide: { border: '1px dashed #d1d5db', borderRadius: 6, padding: theme.spacing(2), color: '#6b7280', backgroundColor: '#f9fafb' },
  simulationGrid: { display: 'grid', gridTemplateColumns: 'minmax(280px, 1fr) minmax(280px, 1fr)', gap: theme.spacing(2) },
  simulationGridTrois: { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(220px, 1fr))', gap: theme.spacing(2) },
  '@media (max-width: 900px)': {
    layout: { gridTemplateColumns: '1fr' },
    simulationGrid: { gridTemplateColumns: '1fr' },
    simulationGridTrois: { gridTemplateColumns: '1fr' },
  },
}));

const CockpitLaboratoireInterpretation = ({ section }) => {
  const classes = useStyles();
  const [registre, setRegistre] = useState(null);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');
  const [fluxSelectionneId, setFluxSelectionneId] = useState('');
  const [goldenCases, setGoldenCases] = useState([]);
  const sectionActive = section || 'registre';

  const charger = () => {
    setChargement(true);
    Promise.all([chargerRegistreInterpretation(), chargerBibliothequeGoldenCases()])
      .then(([payloadRegistre, payloadGoldenCases]) => {
        setRegistre(payloadRegistre);
        setGoldenCases(payloadGoldenCases);
        setErreur('');
        setChargement(false);
        const premierFlux = payloadRegistre.flux[0] && idFlux(payloadRegistre.flux[0]);
        if (!fluxSelectionneId && premierFlux) setFluxSelectionneId(premierFlux);
      })
      .catch((err) => {
        setErreur(err.message);
        setChargement(false);
      });
  };

  useEffect(() => {
    charger();
  }, []);

  const fluxSelectionne = useMemo(() => {
    const flux = registre ? registre.flux : [];
    return flux.find((item) => idFlux(item) === fluxSelectionneId) || flux[0] || null;
  }, [registre, fluxSelectionneId]);
  const profilSelectionne = fluxSelectionne && registre ? registre.profilsParFlux[idFlux(fluxSelectionne)] : null;

  return (
    <Container maxWidth={false} className={classes.page}>
      <CockpitNavigation vueActive="laboratoire" />
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <div>
            <Typography variant="h4">Laboratoire d'interpretation</Typography>
            <Typography variant="body2" className={classes.muted}>
              Espace developpeur pour inspecter le registre, valider les profils et preparer les passes du moteur.
            </Typography>
          </div>
          <Button variant="outlined" size="small" onClick={charger} disabled={chargement}>
            {chargement ? 'Chargement...' : 'Recharger les JSON'}
          </Button>
        </div>
        <div className={classes.nav}>
          {PAGES_LABORATOIRE.map((page) => (
            <Button
              key={page.cle}
              component={Link}
              to={page.chemin}
              variant={sectionActive === page.cle ? 'contained' : 'outlined'}
              color={sectionActive === page.cle ? 'primary' : 'default'}
              size="small"
            >
              {page.libelle}
            </Button>
          ))}
        </div>
        {erreur && (
          <div className={classes.zoneVide} style={{ marginTop: 12 }}>
            <Typography variant="subtitle2">Erreur de chargement</Typography>
            <Typography variant="body2">{erreur}</Typography>
          </div>
        )}
      </Paper>
      <TutorielCreationFlux classes={classes} />

      {registre && (
        <React.Fragment>
          {sectionActive !== 'golden-cases' && sectionActive !== 'creation-flux' && (
            <SelectionFlux
              classes={classes}
              flux={registre.flux}
              fluxSelectionne={fluxSelectionne}
              onSelection={(fluxId) => setFluxSelectionneId(fluxId)}
            />
          )}
          {sectionActive === 'registre' && <VueRegistreFlux classes={classes} flux={fluxSelectionne} profil={profilSelectionne} />}
          {sectionActive === 'profils' && <VueProfilInterpretation classes={classes} flux={fluxSelectionne} profil={profilSelectionne} />}
          {sectionActive === 'creation-flux' && <VueCreationFlux classes={classes} registre={registre} />}
          {sectionActive === 'simulation' && (
            <VueSimulation
              classes={classes}
              flux={fluxSelectionne}
              profil={profilSelectionne}
              fluxDisponibles={registre.flux}
              onSelectionFlux={(fluxId) => setFluxSelectionneId(fluxId)}
              onGoldenCaseCree={(goldenCase) => {
                const prochains = sauvegarderGoldenCaseLocal(goldenCase);
                chargerBibliothequeGoldenCases().then(setGoldenCases).catch(() => setGoldenCases(prochains));
              }}
            />
          )}
          {sectionActive === 'golden-cases' && (
            <VueGoldenCases
              classes={classes}
              registre={registre}
              goldenCases={goldenCases}
              onGoldenCasesChange={setGoldenCases}
            />
          )}
        </React.Fragment>
      )}
    </Container>
  );
};

const SelectionFlux = ({ classes, flux, fluxSelectionne, onSelection }) => (
  <Paper className={classes.paper}>
    <div className={classes.header}>
      <div>
        <Typography variant="h6">Flux du registre</Typography>
        <Typography variant="body2" className={classes.muted}>
          Donnees chargees depuis <span className={classes.code}>/registre-flux/*.json</span>.
        </Typography>
      </div>
      <Chip size="small" label={`${flux.length} flux`} className={classes.chipInfo} />
    </div>
    <div className={classes.liste} style={{ marginTop: 12 }}>
      {flux.map((item) => {
        const actif = fluxSelectionne && idFlux(item) === idFlux(fluxSelectionne);
        return (
          <Button
            key={idFlux(item)}
            className={actif ? classes.itemFluxActif : classes.itemFlux}
            onClick={() => onSelection(idFlux(item))}
          >
            <span>
              <strong>{libelleFlux(item)}</strong>
              <br />
              <span className={classes.muted}>{idFlux(item)}</span>
            </span>
          </Button>
        );
      })}
    </div>
  </Paper>
);

const TutorielCreationFlux = ({ classes }) => (
  <Paper className={`${classes.paper} ${classes.tutorielFlux}`}>
    <div className={classes.header}>
      <div>
        <Typography variant="h6">Memo rapide - creer un flux d'interpretation</Typography>
        <Typography variant="body2" className={classes.muted}>
          Aide embarquee pour eviter de refaire l'enquete la prochaine fois.
        </Typography>
      </div>
      <Chip size="small" label="Tutoriel" className={classes.chipInfo} />
    </div>
    <Grid container spacing={2} style={{ marginTop: 4 }}>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">1. Declarer le flux</Typography>
        <ol className={classes.tutorielListe}>
          <li className={classes.tutorielItem}>
            Creer <span className={classes.code}>public/registre-flux/flux-&lt;nom&gt;.json</span> avec l'identite, la mission, le perimetre, les objets traverses, les interfaces, les jalons, les dependances et l'exposition cockpit.
          </li>
          <li className={classes.tutorielItem}>
            Creer <span className={classes.code}>profil-interpretation-&lt;nom&gt;.json</span> avec les preuves attendues, preuves contradictoires, etats, regles et transitions.
          </li>
          <li className={classes.tutorielItem}>
            Ajouter les deux fichiers dans <span className={classes.code}>public/registre-flux/index.json</span>.
          </li>
        </ol>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">2. Rendre le flux exploitable</Typography>
        <ol className={classes.tutorielListe}>
          <li className={classes.tutorielItem}>
            Demarrer en brouillon si le premier log reel n'existe pas encore; les selecteurs de preuves restent alors provisoires.
          </li>
          <li className={classes.tutorielItem}>
            Quand un log reel arrive, ajuster le parseur, la projection canonique, les cles de correlation et les tests.
          </li>
          <li className={classes.tutorielItem}>
            Ajouter un Golden Case reel, puis brancher le flux dans la projection de session seulement si le cockpit doit afficher un diagnostic vivant.
          </li>
        </ol>
      </Grid>
    </Grid>
    <Typography variant="body2" className={classes.muted}>
      Pense-bete: le registre documente le flux; le profil detecte les preuves; le moteur/projection rend le diagnostic visible en exploitation.
    </Typography>
  </Paper>
);

const VueRegistreFlux = ({ classes, flux, profil }) => {
  if (!flux) return <EtatVide classes={classes} message="Aucun flux disponible dans le registre." />;
  return (
    <div className={classes.layout}>
      <Paper className={classes.paper}>
        <Typography variant="h6">Resume</Typography>
        <Champ classes={classes} label="Identite" valeur={flux.identite && flux.identite.id} />
        <Champ classes={classes} label="Nom" valeur={flux.identite && flux.identite.nom} />
        <Champ classes={classes} label="Statut" valeur={flux.identite && flux.identite.statut} />
        <Champ classes={classes} label="Profil associe" valeur={profil ? libelleProfil(profil) : 'Aucun profil associe'} />
        <Champ classes={classes} label="Source" valeur={flux.__cheminRegistre} />
      </Paper>
      <div>
        <BlocObjet classes={classes} titre="Identite" objet={flux.identite} />
        <BlocObjet classes={classes} titre="Mission" objet={flux.mission} />
        <BlocObjet classes={classes} titre="Perimetre" objet={flux.perimetre} />
        <BlocTableauObjets classes={classes} titre="Objets traverses" items={flux.objets_traverses} colonnes={['type', 'role', 'cardinalite', 'cle_correlation']} />
        <BlocObjet classes={classes} titre="Interfaces" objet={flux.interfaces} />
        <BlocTableauObjets classes={classes} titre="Jalons" items={flux.jalons} colonnes={['ordre', 'id', 'nom', 'objet', 'role']} />
        <BlocObjet classes={classes} titre="Dependances" objet={flux.dependances} />
        <BlocObjet classes={classes} titre="Criticite" objet={flux.criticite} />
        <BlocObjet classes={classes} titre="Exposition cockpit" objet={flux.exposition_cockpit} />
        <BlocObjet classes={classes} titre="Versionnage" objet={flux.versionnage} />
      </div>
    </div>
  );
};

const VueProfilInterpretation = ({ classes, flux, profil }) => {
  if (!flux) return <EtatVide classes={classes} message="Aucun flux selectionne." />;
  if (!profil) return <EtatVide classes={classes} message="Aucun ProfilInterpretationFlux associe a ce flux." />;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Typography variant="h5">{libelleProfil(profil)}</Typography>
          <Typography variant="body2" className={classes.muted}>
            Profil associe a {libelleFlux(flux)}. Source: <span className={classes.code}>{profil.__cheminRegistre}</span>
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <BlocPreuves classes={classes} titre="Preuves attendues" preuves={profil.preuves_attendues} />
      </Grid>
      <Grid item xs={12} md={6}>
        <BlocPreuves classes={classes} titre="Preuves contradictoires" preuves={profil.preuves_contradictoires} contradictoire />
      </Grid>
      <Grid item xs={12}>
        <BlocTableauObjets classes={classes} titre="Etats" items={profil.etats} colonnes={['id', 'categorie', 'severite', 'terminal', 'visible_cockpit']} />
      </Grid>
      <Grid item xs={12}>
        <BlocRegles classes={classes} regles={profil.regles_interpretation} />
      </Grid>
      <Grid item xs={12} md={6}>
        <BlocTableauObjets classes={classes} titre="Transitions" items={profil.transitions} colonnes={['id', 'depuis', 'vers', 'declencheur']} />
      </Grid>
      <Grid item xs={12} md={6}>
        <BlocObjet classes={classes} titre="Portee et observation" objet={{ portee: profil.portee, observation: profil.observation, versionnage: profil.versionnage }} />
      </Grid>
    </Grid>
  );
};

const VueSimulation = ({ classes, flux, profil, fluxDisponibles, onSelectionFlux, onGoldenCaseCree }) => {
  const [log, setLog] = useState('');
  const [formulaireOuvert, setFormulaireOuvert] = useState(false);
  const [nomGoldenCase, setNomGoldenCase] = useState('');
  const [descriptionGoldenCase, setDescriptionGoldenCase] = useState('');
  const [referenceLogGoldenCase, setReferenceLogGoldenCase] = useState('');
  const [remarquesGoldenCase, setRemarquesGoldenCase] = useState('');
  const [messageGoldenCase, setMessageGoldenCase] = useState('');
  const resultat = useMemo(() => detecterPreuvesDepuisLog(profil, log), [profil, log]);
  const diagnostic = resultat && resultat.diagnostic ? resultat.diagnostic : {};

  const ouvrirFormulaireGoldenCase = () => {
    const nomParDefaut = `${libelleFlux(flux)} - ${missionLisible(diagnostic.mission)}`;
    if (!nomGoldenCase) setNomGoldenCase(nomParDefaut);
    if (!descriptionGoldenCase) setDescriptionGoldenCase(diagnostic.raison_principale || '');
    setFormulaireOuvert(true);
  };

  const creerGoldenCase = () => {
    const goldenCase = creerGoldenCaseDepuisSimulation({
      nom: nomGoldenCase || `Diagnostic ${diagnostic.mission || 'indetermine'}`,
      description: descriptionGoldenCase,
      flux,
      profil,
      extraitLog: log,
      referenceLog: referenceLogGoldenCase,
      resultat,
      remarques: remarquesGoldenCase,
    });
    onGoldenCaseCree(goldenCase);
    setMessageGoldenCase('Golden Case enregistre dans la bibliotheque locale du laboratoire.');
    setFormulaireOuvert(false);
    setNomGoldenCase('');
    setDescriptionGoldenCase('');
    setReferenceLogGoldenCase('');
    setRemarquesGoldenCase('');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h5">Simulation</Typography>
              <Typography variant="body2" className={classes.muted}>
                Atelier de developpement: log, premiere passe deterministe, diagnostic, validation humaine puis Golden Case.
              </Typography>
            </div>
            <div>
              <select className={classes.select} value={flux ? idFlux(flux) : ''} onChange={(e) => onSelectionFlux(e.target.value)}>
                {fluxDisponibles.map((item) => <option key={idFlux(item)} value={idFlux(item)}>{libelleFlux(item)}</option>)}
              </select>
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12} md={5}>
        <Paper className={classes.paper}>
          <Typography variant="h6">Workflow</Typography>
          <div className={classes.zoneVide}>
            Log reel -> simulation -> premiere passe -> diagnostic -> validation humaine -> Golden Case.
          </div>
          {messageGoldenCase && (
            <Typography variant="body2" className={classes.muted} style={{ marginTop: 8 }}>
              {messageGoldenCase}
            </Typography>
          )}
          <Typography variant="h6" style={{ marginTop: 16 }}>Extrait de log</Typography>
          <TextField
            fullWidth
            multiline
            rows={14}
            variant="outlined"
            value={log}
            onChange={(e) => setLog(e.target.value)}
            placeholder="Collez ici un extrait de log SyncCam..."
          />
          {formulaireOuvert && (
            <div className={classes.bloc} style={{ marginTop: 16 }}>
              <Typography variant="h6">Nouveau Golden Case</Typography>
              <TextField
                fullWidth
                margin="dense"
                label="Nom"
                variant="outlined"
                value={nomGoldenCase}
                onChange={(e) => setNomGoldenCase(e.target.value)}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Description"
                variant="outlined"
                value={descriptionGoldenCase}
                onChange={(e) => setDescriptionGoldenCase(e.target.value)}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Reference du log"
                variant="outlined"
                value={referenceLogGoldenCase}
                onChange={(e) => setReferenceLogGoldenCase(e.target.value)}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Remarques"
                variant="outlined"
                multiline
                rows={3}
                value={remarquesGoldenCase}
                onChange={(e) => setRemarquesGoldenCase(e.target.value)}
              />
              <div className={classes.grille} style={{ marginTop: 8 }}>
                <Champ classes={classes} label="Flux concerne" valeur={flux && idFlux(flux)} />
                <Champ classes={classes} label="Mission attendue" valeur={missionLisible(diagnostic.mission)} />
                <Champ classes={classes} label="Etat attendu" valeur={etatLisible(diagnostic.etat_flux)} />
                <Champ classes={classes} label="Raison principale" valeur={diagnostic.raison_principale} />
                <Champ classes={classes} label="Preuves detectees" valeur={idsObjets(resultat.detectees).join(', ')} />
                <Champ classes={classes} label="Contradictions" valeur={idsObjets(resultat.contradictions).join(', ')} />
                <Champ classes={classes} label="Extrait de log" valeur={`${log.length} caracteres conserves`} />
              </div>
              <Button variant="contained" color="primary" size="small" onClick={creerGoldenCase}>
                Enregistrer
              </Button>
              <Button variant="outlined" size="small" style={{ marginLeft: 8 }} onClick={() => setFormulaireOuvert(false)}>
                Annuler
              </Button>
            </div>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} md={7}>
        <BlocDiagnosticFlux
          classes={classes}
          diagnostic={resultat.diagnostic}
          action={(
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={!log || !profil}
              onClick={ouvrirFormulaireGoldenCase}
            >
              Creer un Golden Case
            </Button>
          )}
        />
        <div className={classes.simulationGridTrois}>
          <BlocPreuves classes={classes} titre="Preuves detectees" preuves={resultat.detectees} />
          <BlocContradictions classes={classes} contradictions={resultat.contradictions} />
          <BlocPreuves classes={classes} titre="Preuves absentes" preuves={resultat.absentes} />
        </div>
        <Paper className={classes.paper}>
          <Typography variant="h6">Jalons</Typography>
          <Typography variant="caption" className={classes.muted}>Atteints</Typography>
          <ListeChips classes={classes} items={resultat.jalons_atteints} classeChip={classes.chipOk} messageVide="Aucun jalon atteint." />
          <Typography variant="caption" className={classes.muted}>Non atteints</Typography>
          <ListeChips classes={classes} items={resultat.jalons_non_atteints} classeChip={classes.chipWarn} messageVide="Aucun jalon manquant." />
        </Paper>
      </Grid>
    </Grid>
  );
};

const VueCreationFlux = ({ classes, registre }) => {
  const [formulaire, setFormulaire] = useState({
    nom: '',
    identifiant: '',
    mission: '',
    descriptionCourte: '',
    granularite: 'segment',
  });
  const [identifiantModifie, setIdentifiantModifie] = useState(false);
  const [log, setLog] = useState('');
  const [groupes, setGroupes] = useState([]);
  const [annotations, setAnnotations] = useState([]);
  const [message, setMessage] = useState('');
  const [simulation, setSimulation] = useState(null);

  const changerChamp = (champ, valeur) => {
    setFormulaire((courant) => {
      const prochain = { ...courant, [champ]: valeur };
      if (champ === 'nom' && !identifiantModifie) prochain.identifiant = proposerIdentifiantFlux(valeur);
      if (champ === 'identifiant') prochain.identifiant = proposerIdentifiantFlux(valeur);
      return prochain;
    });
    if (champ === 'identifiant') setIdentifiantModifie(true);
  };

  const analyserLog = () => {
    const evenements = extraireEvenementsDepuisLog(log);
    const prochainsGroupes = regrouperEvenements(evenements);
    setGroupes(prochainsGroupes);
    setAnnotations(prochainsGroupes.map((groupe) => ({
      type: groupe.type,
      classification: 'ignore',
      nomMetier: '',
      forceProbante: 'contextuelle',
    })));
    setSimulation(null);
    setMessage(`${prochainsGroupes.length} type(s) d'evenements detecte(s).`);
  };

  const changerAnnotation = (type, champ, valeur) => {
    setAnnotations((courantes) => courantes.map((annotation) => (
      annotation.type === type ? { ...annotation, [champ]: valeur } : annotation
    )));
  };

  const fluxBrouillon = useMemo(() => genererFluxBrouillon(formulaire), [formulaire]);
  const profilBrouillon = useMemo(() => genererProfilBrouillon(formulaire, annotations), [formulaire, annotations]);
  const entreeIndex = useMemo(() => genererEntreeIndexBrouillon(formulaire), [formulaire]);
  const registreTemporaire = useMemo(
    () => fusionnerRegistreAvecBrouillon(registre, fluxBrouillon, profilBrouillon),
    [registre, fluxBrouillon, profilBrouillon]
  );

  const copier = (objet, libelle) => {
    const texte = JSON.stringify(objet, null, 2);
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(texte)
        .then(() => setMessage(`${libelle} copie dans le presse-papiers.`))
        .catch(() => setMessage(`Copie indisponible pour ${libelle}. Le contenu reste visible dans la previsualisation.`));
    } else {
      setMessage(`Copie indisponible pour ${libelle}. Le contenu reste visible dans la previsualisation.`);
    }
  };

  const testerBrouillon = () => {
    const profilTemporaire = registreTemporaire.profilsParFlux[fluxBrouillon.identite.id];
    const resultat = detecterPreuvesDepuisLog(profilTemporaire, log);
    setSimulation({
      registre: registreTemporaire,
      flux: fluxBrouillon,
      profil: profilTemporaire,
      resultat,
      executeLe: new Date().toISOString(),
    });
    setMessage('Simulation executee avec le registre temporaire en memoire.');
  };

  const annotationsParType = {};
  annotations.forEach((annotation) => { annotationsParType[annotation.type] = annotation; });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h5">Creation de flux</Typography>
              <Typography variant="body2" className={classes.muted}>
                Log reel -> evenements detectes -> selection des preuves -> generation du brouillon -> simulation.
              </Typography>
            </div>
            <Chip size="small" label="Brouillon en memoire" className={classes.chipWarn} />
          </div>
          {message && <Typography variant="body2" className={classes.muted} style={{ marginTop: 8 }}>{message}</Typography>}
        </Paper>
      </Grid>

      <Grid item xs={12} md={5}>
        <Paper className={classes.paper}>
          <Typography variant="h6">1. Identite minimale</Typography>
          <TextField fullWidth required margin="dense" label="Nom du flux" variant="outlined" value={formulaire.nom} onChange={(e) => changerChamp('nom', e.target.value)} />
          <TextField fullWidth required margin="dense" label="Identifiant propose" variant="outlined" value={formulaire.identifiant} onChange={(e) => changerChamp('identifiant', e.target.value)} />
          <TextField fullWidth required margin="dense" label="Mission" variant="outlined" value={formulaire.mission} onChange={(e) => changerChamp('mission', e.target.value)} />
          <TextField fullWidth required margin="dense" label="Description courte" variant="outlined" value={formulaire.descriptionCourte} onChange={(e) => changerChamp('descriptionCourte', e.target.value)} />
          <Typography variant="caption" className={classes.muted}>Granularite</Typography>
          <select className={classes.selectCompact} value={formulaire.granularite} onChange={(e) => changerChamp('granularite', e.target.value)}>
            <option value="segment">segment</option>
            <option value="session">session</option>
            <option value="match">match</option>
            <option value="autre">autre</option>
          </select>
        </Paper>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <Typography variant="h6">2. Collage et analyse du log</Typography>
            <Button variant="contained" color="primary" size="small" onClick={analyserLog} disabled={!log.trim()}>
              Analyser le log
            </Button>
          </div>
          <TextField
            fullWidth
            multiline
            rows={16}
            variant="outlined"
            value={log}
            onChange={(e) => setLog(e.target.value)}
            placeholder="2026-07-23T10:15:00Z | level=INFO | event=CAMERA_FINALIZE_OK | source=synccam | cam=114"
          />
        </Paper>
      </Grid>

      <Grid item xs={12} md={7}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h6">3. Evenements detectes</Typography>
              <Typography variant="body2" className={classes.muted}>
                Les suggestions restent indicatives; la classification initiale est toujours ignoree.
              </Typography>
            </div>
            <Chip size="small" label={`${groupes.length} groupes`} className={classes.chipInfo} />
          </div>
          <div className={classes.tableScroll}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Evenement</TableCell>
                  <TableCell>Occurrences</TableCell>
                  <TableCell>Ligne representative</TableCell>
                  <TableCell>Classification</TableCell>
                  <TableCell>Nom metier</TableCell>
                  <TableCell>Force</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groupes.map((groupe) => {
                  const annotation = annotationsParType[groupe.type] || {};
                  return (
                    <TableRow key={groupe.type}>
                      <TableCell>
                        <Typography variant="body2" className={classes.code}>{groupe.type}</Typography>
                        {groupe.suggestion !== 'indetermine' && (
                          <Chip size="small" label={`suggestion: ${groupe.suggestion}`} className={groupe.suggestion === 'preuve' ? classes.chipOk : classes.chipDanger} />
                        )}
                      </TableCell>
                      <TableCell>{groupe.nombreOccurrences}</TableCell>
                      <TableCell><Typography variant="body2" className={classes.code}>{groupe.ligneRepresentative}</Typography></TableCell>
                      <TableCell>
                        <select className={classes.selectCompact} value={annotation.classification || 'ignore'} onChange={(e) => changerAnnotation(groupe.type, 'classification', e.target.value)}>
                          <option value="preuve">preuve</option>
                          <option value="contradiction">contradiction</option>
                          <option value="ignore">ignore</option>
                        </select>
                      </TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          margin="dense"
                          variant="outlined"
                          value={annotation.nomMetier || ''}
                          onChange={(e) => changerAnnotation(groupe.type, 'nomMetier', e.target.value)}
                          placeholder="Nom metier"
                        />
                      </TableCell>
                      <TableCell>
                        <select className={classes.selectCompact} value={annotation.forceProbante || 'contextuelle'} onChange={(e) => changerAnnotation(groupe.type, 'forceProbante', e.target.value)}>
                          <option value="requise">requise</option>
                          <option value="confirmante">confirmante</option>
                          <option value="contextuelle">contextuelle</option>
                        </select>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {groupes.length === 0 && (
                  <TableRow><TableCell colSpan={6}>Aucun evenement detecte. Collez un log puis lancez l'analyse.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </Paper>

        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h6">4. Brouillon genere</Typography>
              <Typography variant="body2" className={classes.muted}>
                Previsualisation seulement: aucun fichier n'est ecrit dans le registre permanent.
              </Typography>
            </div>
            <div className={classes.actionsInline}>
              <Button variant="outlined" size="small" onClick={() => copier(fluxBrouillon, 'Flux')}>Copier le flux</Button>
              <Button variant="outlined" size="small" onClick={() => copier(profilBrouillon, 'Profil')}>Copier le profil</Button>
              <Button variant="contained" color="primary" size="small" onClick={testerBrouillon} disabled={!log.trim()}>
                Tester dans le simulateur
              </Button>
            </div>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}><BlocObjet classes={classes} titre={`flux-${formulaire.identifiant || 'nouveau-flux'}.json`} objet={fluxBrouillon} /></Grid>
            <Grid item xs={12} md={4}><BlocObjet classes={classes} titre={`profil-interpretation-${formulaire.identifiant || 'nouveau-flux'}.json`} objet={profilBrouillon} /></Grid>
            <Grid item xs={12} md={4}><BlocObjet classes={classes} titre="Proposition index.json" objet={entreeIndex} /></Grid>
          </Grid>
        </Paper>
      </Grid>

      {simulation && (
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <div className={classes.header}>
              <div>
                <Typography variant="h5">Simulation du brouillon</Typography>
                <Typography variant="body2" className={classes.muted}>
                  Executee avec {simulation.flux.identite.id}, present uniquement dans le registre temporaire en memoire.
                </Typography>
              </div>
              <Chip size="small" label={formaterDate(simulation.executeLe)} className={classes.chipInfo} />
            </div>
          </Paper>
          <BlocDiagnosticFlux classes={classes} diagnostic={simulation.resultat.diagnostic} />
          <div className={classes.simulationGridTrois}>
            <BlocPreuves classes={classes} titre="Preuves detectees" preuves={simulation.resultat.detectees} />
            <BlocContradictions classes={classes} contradictions={simulation.resultat.contradictions} />
            <BlocPreuves classes={classes} titre="Preuves absentes" preuves={simulation.resultat.absentes} />
          </div>
        </Grid>
      )}
    </Grid>
  );
};

const VueGoldenCases = ({ classes, registre, goldenCases, onGoldenCasesChange }) => {
  const [selectionId, setSelectionId] = useState('');
  const [executionSelection, setExecutionSelection] = useState(null);
  const [resumeExecution, setResumeExecution] = useState(null);
  const selection = goldenCases.find((item) => item.identite && item.identite.id === selectionId) || goldenCases[0] || null;
  const resultatsParId = {};
  ((resumeExecution && resumeExecution.executions) || []).forEach((execution) => {
    resultatsParId[execution.goldenCase.identite.id] = execution.comparaison;
  });
  if (executionSelection && executionSelection.goldenCase && executionSelection.goldenCase.identite) {
    resultatsParId[executionSelection.goldenCase.identite.id] = executionSelection.comparaison;
  }

  const enregistrerBibliotheque = (prochains) => {
    const sauvegardes = sauvegarderBibliothequeGoldenCasesLocale(prochains);
    onGoldenCasesChange(sauvegardes);
  };

  const executerCas = (goldenCase) => {
    if (!goldenCase) return;
    const execution = executerGoldenCase(goldenCase, registre);
    setExecutionSelection(execution);
    setResumeExecution(null);
    const misAJour = goldenCases.map((item) => (
      item.identite.id === goldenCase.identite.id
        ? {
          ...item,
          validation: {
            derniere_execution: execution.comparaison.execute_le,
            dernier_statut: execution.comparaison.statut,
            dernier_resume: {
              differences: execution.comparaison.differences.length,
            },
          },
        }
        : item
    ));
    enregistrerBibliotheque(misAJour);
  };

  useEffect(() => {
    if (!selection || !registre) return;
    executerCas(selection);
  }, [selection && selection.identite && selection.identite.id, registre]);

  const executerSelection = () => {
    executerCas(selection);
  };

  const executerTous = () => {
    const resume = executerGoldenCases(goldenCases, registre);
    setResumeExecution(resume);
    setExecutionSelection(null);
    const executionsParId = {};
    resume.executions.forEach((execution) => {
      executionsParId[execution.goldenCase.identite.id] = execution;
    });
    enregistrerBibliotheque(goldenCases.map((item) => {
      const execution = executionsParId[item.identite.id];
      if (!execution) return item;
      return {
        ...item,
        validation: {
          derniere_execution: execution.comparaison.execute_le,
          dernier_statut: execution.comparaison.statut,
          dernier_resume: {
            differences: execution.comparaison.differences.length,
          },
        },
      };
    }));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h5">Golden Cases - tests du moteur</Typography>
              <Typography variant="body2" className={classes.muted}>
                Bibliotheque de validations: chaque cas verifie que le moteur reproduit le diagnostic attendu.
              </Typography>
            </div>
            <Button variant="contained" color="primary" size="small" disabled={goldenCases.length === 0} onClick={executerTous}>
              Relancer les validations
            </Button>
          </div>
          {resumeExecution && (
            <div className={classes.grille} style={{ marginTop: 12 }}>
              <Champ classes={classes} label="Tests Golden Cases" valeur={resumeExecution.total} />
              <Champ classes={classes} label="Validations reussies" valeur={resumeExecution.conformes} />
              <Champ classes={classes} label="Regressions detectees" valeur={resumeExecution.regressions} />
            </div>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12} md={7}>
        <Paper className={classes.paper}>
          <Typography variant="h6">Bibliotheque de tests de validation</Typography>
          <div className={classes.tableScroll}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell>Flux</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Diagnostic attendu</TableCell>
                  <TableCell>Etat attendu</TableCell>
                  <TableCell>Mission attendue</TableCell>
                  <TableCell>Derniere validation</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Version</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {goldenCases.map((goldenCase) => {
                  const id = goldenCase.identite && goldenCase.identite.id;
                  const comparaison = resultatsParId[id];
                  const dernierStatut = comparaison ? comparaison.statut : goldenCase.validation && goldenCase.validation.dernier_statut;
                  return (
                    <TableRow key={id} hover selected={selection && selection.identite.id === id} onClick={() => setSelectionId(id)}>
                      <TableCell>{goldenCase.identite && goldenCase.identite.nom}</TableCell>
                      <TableCell>{goldenCase.identite && goldenCase.identite.flux_id}</TableCell>
                      <TableCell>{goldenCase.identite && goldenCase.identite.description}</TableCell>
                      <TableCell>{goldenCase.attendu && goldenCase.attendu.raison_principale}</TableCell>
                      <TableCell>{etatLisible(goldenCase.attendu && goldenCase.attendu.etat_flux)}</TableCell>
                      <TableCell>{missionLisible(goldenCase.attendu && goldenCase.attendu.mission)}</TableCell>
                      <TableCell>
                        <Chip size="small" label={statutValidationLisible(dernierStatut)} className={classeStatut(classes, dernierStatut)} />
                      </TableCell>
                      <TableCell>{formaterDate(goldenCase.identite && goldenCase.identite.cree_le)}</TableCell>
                      <TableCell>{goldenCase.identite && goldenCase.identite.version}</TableCell>
                    </TableRow>
                  );
                })}
                {goldenCases.length === 0 && (
                  <TableRow><TableCell colSpan={9}>Aucun test Golden Case. Creez-en un depuis une simulation validee.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12} md={5}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <Typography variant="h6">Test selectionne</Typography>
            <Button variant="outlined" size="small" disabled={!selection} onClick={executerSelection}>Relancer la validation</Button>
          </div>
          {selection ? (
            <React.Fragment>
              <div className={classes.zoneVide} style={{ marginBottom: 12 }}>
                Test de validation du moteur: entree connue, diagnostic attendu, resultat a conserver sans regression.
              </div>
              <Champ classes={classes} label="Nom" valeur={selection.identite && selection.identite.nom} />
              <Champ classes={classes} label="Flux charge" valeur={selection.identite && selection.identite.flux_id} />
              <Champ classes={classes} label="Log charge" valeur={`${(selection.entree && selection.entree.extrait_log ? selection.entree.extrait_log : '').length} caracteres`} />
              <Champ classes={classes} label="Mission attendue" valeur={missionLisible(selection.attendu && selection.attendu.mission)} />
              <Champ classes={classes} label="Etat attendu" valeur={etatLisible(selection.attendu && selection.attendu.etat_flux)} />
              <Champ classes={classes} label="Diagnostic attendu" valeur={selection.attendu && selection.attendu.raison_principale} />
              <BlocObjet classes={classes} titre="Extrait de log associe" objet={selection.entree && selection.entree.extrait_log} />
            </React.Fragment>
          ) : (
            <div className={classes.zoneVide}>Aucun cas selectionne.</div>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <BlocExecutionGoldenCase classes={classes} execution={executionSelection} resume={resumeExecution} />
      </Grid>
    </Grid>
  );
};

const BlocExecutionGoldenCase = ({ classes, execution, resume }) => {
  if (!execution && !resume) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6">Resultat de validation</Typography>
        <div className={classes.zoneVide}>Relancez un test ou toute la bibliotheque pour comparer le diagnostic attendu et le diagnostic obtenu.</div>
      </Paper>
    );
  }

  if (resume) {
    return (
      <Paper className={classes.paper}>
        <Typography variant="h6">Validation de la bibliotheque</Typography>
        {(resume.executions || []).map((item) => (
          <div key={item.goldenCase.identite.id} className={classes.bloc}>
            <div className={classes.header}>
              <Typography variant="subtitle2">{item.goldenCase.identite.nom}</Typography>
              <Chip
                size="small"
                label={item.comparaison.conforme ? 'Validation reussie' : 'Regression detectee'}
                className={item.comparaison.conforme ? classes.chipOk : classes.chipDanger}
              />
            </div>
            {!item.comparaison.conforme && <BlocDifferences classes={classes} differences={item.comparaison.differences} />}
          </div>
        ))}
      </Paper>
    );
  }

  return (
    <Paper className={classes.paper}>
      <div className={classes.header}>
        <Typography variant="h6">Resultat de validation du moteur</Typography>
        <Chip
          size="small"
          label={execution.comparaison.conforme ? 'Validation reussie' : 'Validation echouee - regression detectee'}
          className={execution.comparaison.conforme ? classes.chipOk : classes.chipDanger}
        />
      </div>
      <div className={classes.grille} style={{ marginTop: 12 }}>
        <Champ classes={classes} label="Mission attendue" valeur={missionLisible(execution.comparaison.attendu.mission)} />
        <Champ classes={classes} label="Mission obtenue" valeur={missionLisible(execution.comparaison.obtenu.mission)} />
        <Champ classes={classes} label="Etat attendu" valeur={etatLisible(execution.comparaison.attendu.etat_flux)} />
        <Champ classes={classes} label="Etat obtenu" valeur={etatLisible(execution.comparaison.obtenu.etat_flux)} />
      </div>
      <div className={classes.grille}>
        <Champ classes={classes} label="Diagnostic attendu" valeur={execution.comparaison.attendu.raison_principale} />
        <Champ classes={classes} label="Diagnostic obtenu" valeur={execution.comparaison.obtenu.raison_principale} />
      </div>
      <BlocDifferences classes={classes} differences={execution.comparaison.differences} />
      <BlocObjet classes={classes} titre="Comparaison brute" objet={execution.comparaison} />
    </Paper>
  );
};

const BlocDifferences = ({ classes, differences }) => (
  <div>
    {(differences || []).length > 0 ? (
      <div className={classes.tableScroll}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Champ</TableCell>
              <TableCell>Attendu</TableCell>
              <TableCell>Obtenu</TableCell>
              <TableCell>Ecart</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {differences.map((difference) => (
              <TableRow key={difference.champ}>
                <TableCell>{difference.champ}</TableCell>
                <TableCell>{formatValeurCellule(difference.attendu)}</TableCell>
                <TableCell>{formatValeurCellule(difference.obtenu)}</TableCell>
                <TableCell>
                  {difference.manquants && difference.manquants.length > 0 && <Typography variant="body2">Manquants: {difference.manquants.join(', ')}</Typography>}
                  {difference.ajoutes && difference.ajoutes.length > 0 && <Typography variant="body2">Ajoutes: {difference.ajoutes.join(', ')}</Typography>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    ) : (
      <Typography variant="body2" className={classes.muted}>Aucune difference detectee.</Typography>
    )}
  </div>
);

const ListeChips = ({ classes, items, classeChip, messageVide }) => (
  <div style={{ marginTop: 4, marginBottom: 10 }}>
    {(items || []).length > 0 ? (
      items.map((item) => <Chip key={item} size="small" label={item} className={classeChip || classes.chipInfo} style={{ marginRight: 6, marginBottom: 6 }} />)
    ) : (
      <Typography variant="body2" className={classes.muted}>{messageVide || 'Aucun element.'}</Typography>
    )}
  </div>
);

const BlocPreuves = ({ classes, titre, preuves, contradictoire }) => (
  <Paper className={classes.paper}>
    <Typography variant="h6">{titre}</Typography>
    {(preuves || []).map((preuve) => (
      <div key={preuve.id} className={classes.bloc}>
        <div className={classes.header}>
          <Typography variant="subtitle2">{preuve.id}</Typography>
          <Chip size="small" label={preuve.force_probante || preuve.type_preuve || 'preuve'} className={contradictoire ? classes.chipDanger : classes.chipOk} />
        </div>
        <Typography variant="body2" className={classes.muted}>
          {preuve.jalon || preuve.etat_induit || 'Sans jalon'} | {preuve.source && preuve.source.id_source}
        </Typography>
        <Typography variant="body2" className={classes.code}>
          {preuve.selecteur ? `${preuve.selecteur.champ} ${preuve.selecteur.operateur} ${preuve.selecteur.valeur}` : 'Selecteur absent'}
        </Typography>
      </div>
    ))}
    {(!preuves || preuves.length === 0) && <Typography variant="body2" className={classes.muted}>Aucun element.</Typography>}
  </Paper>
);

const BlocContradictions = ({ classes, contradictions }) => (
  <Paper className={classes.paper}>
    <Typography variant="h6">Contradictions</Typography>
    {(contradictions || []).map((contradiction) => (
      <div key={contradiction.id} className={classes.bloc}>
        <div className={classes.header}>
          <Typography variant="subtitle2">{contradiction.id}</Typography>
          <Chip size="small" label={contradiction.confiance || 'confiance n/d'} className={classes.chipDanger} />
        </div>
        <Typography variant="body2">{contradiction.raison}</Typography>
        <Typography variant="body2" className={classes.muted}>
          {(contradiction.preuves || []).map((preuve) => preuve.id).join(' + ') || 'Aucune preuve associee'}
        </Typography>
        <Typography variant="body2" className={classes.code}>
          {contradiction.source || 'profil'}
        </Typography>
      </div>
    ))}
    {(!contradictions || contradictions.length === 0) && <Typography variant="body2" className={classes.muted}>Aucune contradiction detectee.</Typography>}
  </Paper>
);

const BlocDiagnosticFlux = ({ classes, diagnostic, action }) => (
  <Paper className={classes.diagnosticHero}>
    <div className={classes.diagnosticTitre}>
      <div>
        <Typography variant="overline" className={classes.muted}>Premiere passe du moteur</Typography>
        <Typography variant="h5">Diagnostic du flux</Typography>
      </div>
      <Chip size="small" label={missionLisible(diagnostic && diagnostic.mission)} className={classeMission(classes, diagnostic && diagnostic.mission)} />
    </div>
    <Typography className={classes.diagnosticMission}>
      Mission: {missionLisible(diagnostic && diagnostic.mission)}
    </Typography>
    <Typography className={classes.diagnosticEtat}>
      Etat: {etatLisible(diagnostic && diagnostic.etat_flux)}
    </Typography>
    <div className={classes.diagnosticRaison}>
      <Typography variant="caption" className={classes.muted}>Raison principale</Typography>
      <Typography variant="body1">{(diagnostic && diagnostic.raison_principale) || '-'}</Typography>
    </div>
    <div className={classes.grille} style={{ marginTop: 12 }}>
      <Champ classes={classes} label="Niveau de certitude" valeur={diagnostic && diagnostic.niveau_certitude} />
      <Champ classes={classes} label="Regle principale" valeur={diagnostic && diagnostic.regle_principale} />
    </div>
    {action && <div className={classes.actionValidation}>{action}</div>}
  </Paper>
);

const BlocRegles = ({ classes, regles }) => (
  <Paper className={classes.paper}>
    <Typography variant="h6">Regles et actions</Typography>
    {(regles || []).map((regle) => (
      <div key={regle.id} className={classes.bloc}>
        <div className={classes.header}>
          <Typography variant="subtitle1"><strong>{regle.id}</strong></Typography>
          <Chip size="small" label={`priorite ${regle.priorite}`} className={classes.chipInfo} />
        </div>
        <div className={classes.grille}>
          <Condition classes={classes} label="Toutes" valeurs={regle.si && regle.si.toutes} />
          <Condition classes={classes} label="Une des" valeurs={regle.si && regle.si.une_des} />
          <Condition classes={classes} label="Aucune" valeurs={regle.si && regle.si.aucune} />
          <div>
            <Typography variant="caption" className={classes.muted}>Alors</Typography>
            <Typography variant="body2"><strong>{regle.alors && regle.alors.etat}</strong> ({regle.alors && regle.alors.confiance})</Typography>
            {(regle.alors && regle.alors.actions ? regle.alors.actions : []).map((action) => (
              <Chip key={action.type + action.cible} size="small" label={`${action.type} -> ${action.cible}`} className={classes.chipWarn} style={{ marginRight: 4, marginTop: 4 }} />
            ))}
          </div>
        </div>
      </div>
    ))}
  </Paper>
);

const Condition = ({ classes, label, valeurs }) => (
  <div>
    <Typography variant="caption" className={classes.muted}>{label}</Typography>
    {(valeurs || []).length > 0 ? (valeurs || []).map((valeur) => (
      <Typography key={valeur} variant="body2" className={classes.code}>{valeur}</Typography>
    )) : <Typography variant="body2" className={classes.muted}>-</Typography>}
  </div>
);

const BlocObjet = ({ classes, titre, objet }) => (
  <Paper className={classes.paper}>
    <Typography variant="h6">{titre}</Typography>
    <pre className={classes.code}>{JSON.stringify(objet || {}, null, 2)}</pre>
  </Paper>
);

const BlocTableauObjets = ({ classes, titre, items, colonnes }) => (
  <Paper className={classes.paper}>
    <Typography variant="h6">{titre}</Typography>
    <div className={classes.tableScroll}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {colonnes.map((colonne) => <TableCell key={colonne}>{colonne}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {(items || []).map((item, index) => (
            <TableRow key={item.id || item.type || index}>
              {colonnes.map((colonne) => <TableCell key={colonne}>{formatValeurCellule(item[colonne])}</TableCell>)}
            </TableRow>
          ))}
          {(!items || items.length === 0) && (
            <TableRow><TableCell colSpan={colonnes.length}>Aucun element.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  </Paper>
);

const Champ = ({ classes, label, valeur }) => (
  <div className={classes.bloc}>
    <Typography variant="caption" className={classes.muted}>{label}</Typography>
    <Typography variant="body2" className={classes.code}>{valeur || '-'}</Typography>
  </div>
);

const EtatVide = ({ classes, message }) => (
  <Paper className={classes.paper}>
    <div className={classes.zoneVide}>{message}</div>
  </Paper>
);

const formatValeurCellule = (valeur) => {
  if (Array.isArray(valeur)) return valeur.join(', ');
  if (valeur && typeof valeur === 'object') return JSON.stringify(valeur);
  if (typeof valeur === 'boolean') return valeur ? 'oui' : 'non';
  if (valeur === undefined || valeur === null) return '-';
  return String(valeur);
};

const idsObjets = (items) => (
  (items || [])
    .map((item) => item && item.id)
    .filter(Boolean)
);

const missionLisible = (mission) => {
  if (mission === 'accomplie') return 'Accomplie';
  if (mission === 'non accomplie') return 'Non accomplie';
  if (mission === 'indeterminee') return 'Indeterminee';
  return mission || 'Indeterminee';
};

const etatLisible = (etat) => {
  const valeur = String(etat || '');
  if (valeur.indexOf('nominal') >= 0) return 'Normal';
  if (valeur.indexOf('critique') >= 0 || valeur.indexOf('incident') >= 0 || valeur.indexOf('crash') >= 0 || valeur.indexOf('bloque') >= 0) return 'Critique';
  if (valeur.indexOf('preuve_insuffisante') >= 0 || valeur.indexOf('first_bytes_absent') >= 0 || valeur.indexOf('incomplet') >= 0) return 'Degrade';
  if (!valeur || valeur === 'etat:inconnu') return 'Indetermine';
  return valeur;
};

const classeMission = (classes, mission) => {
  if (mission === 'accomplie') return classes.chipOk;
  if (mission === 'non accomplie') return classes.chipDanger;
  return classes.chipWarn;
};

const classeStatut = (classes, statut) => {
  if (statut === 'conforme') return classes.chipOk;
  if (statut === 'regression') return classes.chipDanger;
  return classes.chipWarn;
};

const statutValidationLisible = (statut) => {
  if (statut === 'conforme') return 'Validation reussie';
  if (statut === 'regression') return 'Regression detectee';
  if (statut === 'jamais_execute') return 'Jamais valide';
  return statut || 'Jamais valide';
};

const formaterDate = (valeur) => {
  if (!valeur) return '-';
  const date = new Date(valeur);
  if (Number.isNaN(date.getTime())) return String(valeur);
  return date.toLocaleString('fr-CA');
};

export default CockpitLaboratoireInterpretation;



// WEBPACK FOOTER //
// src/components/cockpit/CockpitLaboratoireInterpretation.js